import { Button, Space, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';
import serviceHelper from '../../../helpers/functions/service.helper';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { CaretDownFilled, CaretUpFilled, DownloadOutlined, LinkOutlined } from '@ant-design/icons';
import moment from 'moment';
import MyInvoisDocumentList from './myinvois_document_list';
import numberHelper from '../../../helpers/functions/number.helper';

const MyInvoisList = ({ filter, }) => {
    const [state, setState] = useState({
        loading : false,
        submitted_document_loading : null,
        // documents : [],
        submissions : [],

        // refresh
        refresh : 0,

        // pagination
        page : 0,
        display_size : 10,
        count : null,
    });
    const [expanded_row_keys, setExpandedRowKeys] = useState(filter?.expand_key ? (filter?.expand_key?.split(",")?.map(Number)) : []);
    const paginateChange = (key, value) => {
        // set state
        setState(state => ({...state, [key] : value}));

        let generate_filter = filter;
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }

    const fetchMyInvoisList = async () => {
        setState(state => ({...state, loading : true, }));

        const { search, status, parks, start_date, end_date, } = filter;
        const myInvoisSubmissionResponse = await myinvoisTransService?.getMyInvoisSubmissionList({
            // filter
            search,
            status,
            park_ids : parks,
            start_date : start_date,
            end_date : end_date,

            // pagination
            page : Math.max(0, state?.page - 1),
            size : state?.display_size,

            // order
            order : "created_at",
            order_position : 'DESC',
        });

        const { count, rows : submissions, } = myInvoisSubmissionResponse?.submissions;
        setState(state => ({...state, loading : false, submissions, count, }));
    }

    useEffect(() => {
        fetchMyInvoisList();
    }, [state?.page, filter])

    return (
        <>
            <Table
            scroll={{x : 400,}}
            dataSource={state?.submissions}
            rowKey={r => r?.submission_id}
            onChange={(pagination, filters, sorter) => {
                // if(sorter){
                //     const { field, order, } = sorter;
                //     const sequel_order = order === 'ascend' ? 'ASC' : 'DESC';
                //     // setSorter(sorter => ({...sorter, key : field, order : sequel_order,}));
                // }
            }}
            expandable={{
                expandedRowKeys : expanded_row_keys,
                expandedRowRender : (record) => (
                    <MyInvoisDocumentList submission_id={record?.submission_id} />
                ),
                expandIcon: ({ expanded, onExpand, record }) =>
                expanded ? (
                    <CaretUpFilled onClick={e => onExpand(record, e)} />
                ) : (
                    <CaretDownFilled onClick={e => onExpand(record, e)} />
                ),
                onExpand : (expanded, record) => {
                    const id = record?.submission_id;
                    let key = [];
                    setExpandedRowKeys(currentRowKey => {
                        if(expanded){
                            // Add the key if not already present
                            key = [...currentRowKey, id];
                        }else{
                            // Remove the key if it's already present
                            key = currentRowKey.filter(key => key !== id);
                        }

                        paginateChange("expand_key", key?.join(","));

                        return key;
                    });
                }
            }}
            pagination={{
                size : state?.display_size,
                current : (state?.count > state?.display_size) ? state?.page : 1, 
                total : state?.count,
                showSizeChanger: false,
                onChange : (page) => paginateChange('page', page)
            }}
            className='hub-table bordered'
            columns={[{
                title : 'Submission ID',
                dataIndex : 'myinvois_submission_id',
                key : 'myinvois_submission_id',
            },{
                title : 'E-Invoice No',
                dataIndex : 'einvoice_no',
                key : 'einvoice_no',
            },{
                title : 'Park',
                dataIndex : 'park_name',
                key : 'park_name',
            },{
                title : 'Submission Type',
                dataIndex : 'submission_type',
                key : 'submission_type',
            },{
                title : 'Status',
                dataIndex : 'status',
                key : 'status',
                render : (status, row, index) => {
                    const { document_count, success_document_count, } = row;
                    return (
                        <>

                            <Space size={2}>
                            <Tag color={status === 'Valid' ? 'success' : 'error'}>{status}</Tag>
                            
                            <Tag color={success_document_count === document_count ? 'success' : 'error'}>
                                {`${success_document_count}/${document_count}`}
                            </Tag>
                            </Space>
                        </>
                    )
                }
            },{
                title : 'Issued Date',
                dataIndex : 'issue_date',
                key : 'issue_date',
                render : (issue_date, row, index) => {
                    return (
                        <>
                            <span>{moment(issue_date)?.format("YYYY-MM-DD hh:mm:ssa")}</span>
                        </>
                    )
                }
            },{
                title : 'Amount',
                dataIndex : 'amount',
                key : 'amount',
                render : (amount, row, index) => {
                    return (
                        <span>RM{numberHelper?.commaNumber(parseFloat(amount), 2)}</span>
                    )
                }
            },]}
            />
        </>
    );
}

export default MyInvoisList;